@if (valuationData != null) {
  <nav  class="navbar sticky-top navbar-expand-lg navbar-light bg-light">
    <div class="container">
      <a class="navbar-brand">
        <fa-icon class="secure-lock" [icon]="faLock"></fa-icon> Mijn Auto Verkoop Partner
      </a>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        @if (acceptForm) {
          <div class="col nav-item">
            <span class="navar-text">Welkom, <b>{{acceptForm.customerFirstName}}</b></span>
          </div>
        }
        <div class="col nav-item">
          <span class="navar-text">Huidig voertuig: {{valuationData.VehicleSpecification.Vehicle.make}} {{valuationData.VehicleSpecification.Vehicle.model}}</span>
        </div>
      </div>
      <ul class="navbar-nav mr-auto sm-2">
        <li class="nav-item">
          <a href="#" class="nav-link" (click)="logout()">Annuleren</a>
        </li>
      </ul>
    </div>
  </nav>
}
